module.exports = __webpack_public_path__ + "static/media/zmien1.8df9e903.jpg";